import axios from 'axios';
import { baseUrl } from '@/config';

const PREFIX_URL = `${baseUrl}/frame`;

export default {
  /**
   * 초기 설정 정보를 반환한다.
   * @author Ju
   * @return {[type]} [description]
   */
  getInitSettings() {
    return axios.get(`${PREFIX_URL}/get-init-settings.do`);
  },
  /**
   * 초기 기준정보를 반환한다.
   * @author Ju
   * @return {[type]} [description]
   */
  getInitBasicinfos() {
    return axios.get(`${PREFIX_URL}/get-init-basicinfos.do`);
  },
};



// WEBPACK FOOTER //
// ./src/api/frame/common.js